<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">{{title}}</div>
        <div class="setting-addel mr-r4">
          <el-button size="mini" @click="onAddButtonClick"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" :disabled="!isAbleDeleted" @click="onDeleteButtonClick"><i class="fas fa-minus"></i></el-button>
        </div>
        <el-button :disabled="!checkedRows.length" @click="onCopyButtonClick">복사</el-button>
      </div>
      <div class="vertical-center-box" align="right">
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper ref="taskTable" :column-default="columnDefault" :data="tableData" :columns="tableColumns"
    :show-search-tool="showSearchTool" :show-custom-header="true" row-class-name="c-dblclick" remote pagination :total="total"
    @row-dblclick="onRowDblClick" @selection-change="onSelectionChange" @condition-change="loadData" @pagination-change="handlerPaginationChange" @total-change="handlerPaginationChange">
      <template slot-scope="scope" slot="detail-slot">
        <span><i class="far fa-search-plus c-pointer" @click.stop="onDetailButtonClick(scope.row)"></i></span>
      </template>
    </el-table-wrapper>
    <!-- 태스크 상세 팝업 -->
    <w-task-detail-list-popup :selected-task="selectedTask" :var-def-grp-list="varDefGrpList" ref="taskDetailPopup"></w-task-detail-list-popup>
    <!-- 태스크 설정 팝업 -->
    <w-task-setting-popup :selected-group="selectedGroupData" :selected-task="selectedTask" :var-def-grp-list="varDefGrpList" @re-load="loadData" ref="taskSettingPopup"></w-task-setting-popup>
  </div>
</template>

<script>
import { cloneDeep, isNil } from 'lodash';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { isTrue, booleanDefine } from '@/utils/boolean';
import { columnDefault, defaultPagination, defaultDetailHeaderColumn } from '@/constants/table';
import msgUtil from '@/utils/message';
import amsSettingsApi from '@/api/settings/server/ams-settings';
import WTaskDetailListPopup from '../popup/TaskDetailListPopup';
import WTaskSettingPopup from '../popup/TaskSettingPopup';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);
const editableFlagFormatter = (row, column, value) => {
  if (isNil(value)) return EMPTY_TEXT;
  return isTrue(value) ? '가능' : '불가';
};
const pagination = cloneDeep(defaultPagination);

export default {
  name: 'WTaskListView',
  components: {
    WTaskDetailListPopup,
    WTaskSettingPopup,
  },
  props: {
    selectedGroupData: {
      type: Object,
    },
  },
  data() {
    return {
      pagination,
      columnDefault,
      total: 0,
      showSearchTool: false,
      tableColumns: [
        // { type: 'selection', selectable: (row) => row.editableFlag === 'Y' },
        { type: 'selection' },
        { prop: 'grpName', label: '태스크 그룹 이름', width: 150, searchable: true, sortable: true, remoteProp: 'grp_name' },
        { prop: 'taskId', label: '태스크 아이디', searchable: true, sortable: true, remoteProp: 'task_id' },
        { prop: 'taskName', label: '태스크 이름', searchable: true, sortable: true, remoteProp: 'task_name', formatter: defaultFormatter },
        { prop: 'action', label: '태스크 구분', width: 100, searchable: true, sortable: true, formatter: defaultFormatter },
        { prop: 'timeout', label: '타임아웃 (초)', width: 100, searchable: true, sortable: true, formatter: defaultFormatter },
        { prop: 'failoverJudgeType', label: '실패 판단 방법', width: 100, searchable: true, sortable: true, remoteProp: 'failover_judge_type', formatter: defaultFormatter },
        { prop: 'orderbyIndex', label: '정렬순서', width: 70, searchable: true, sortable: true, remoteProp: 'orderby_index' },
        // { prop: 'failoverJudgeText', label: '실패 판단 문자열', searchable: true, sortable: true, remoteProp: 'failover_judge_text', formatter: defaultFormatter },
        { prop: 'editableFlag', columnKey: 'editableFlag', label: '수정', width: 70, sortable: true, remoteProp: 'task.editable_flag', formatter: editableFlagFormatter, filters: [{ text: '가능', value: booleanDefine.TRUE_Y }, { text: '불가', value: booleanDefine.FALSE_N }] },
        { ...defaultDetailHeaderColumn, scopedSlot: 'detail-slot' },
      ],
      tableData: [],
      checkedRows: [],
      varDefGrpList: [],
      selectedTask: null,
    };
  },
  computed: {
    title() {
      const title = '태스크 목록';
      return isNil(this.selectedGroupData) || isNil(this.selectedGroupData.grpName) ? title : `[${this.selectedGroupData.grpName}] ${title}`;
    },
    isAbleDeleted() {
      let ableDeleteFlag = true;
      if (this.checkedRows.length > 0) {
        this.checkedRows.forEach((item) => {
          if (item.editableFlag === 'N') {
            ableDeleteFlag = false;
          }
        });
      } else {
        ableDeleteFlag = false;
      }
      return ableDeleteFlag;
    },
  },
  watch: {
    selectedGroupData() {
      this.$nextTick(() => {
        this.$refs.taskTable.clearFilter();
        this.loadData();
      });
    },
  },
  mounted() {
    // 태스크 구분 및 변수 목록 조회
    amsSettingsApi.getVarDefGrpList().then((response) => {
      if (response.data.success) {
        this.varDefGrpList = response.data.data;
      }
    });
  },
  methods: {
    /**
     * 태스크 목록 load
     * @author jeee12
     */
    loadData() {
      const params = this.$refs.taskTable.getParameter();
      if (!isNil(this.selectedGroupData)) {
        params.grpId = this.selectedGroupData.grpId;
      }
      amsSettingsApi.getTaskList(params).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
        }
      });
    },
    /**
     * 추가 버튼 click
     * @author jeee12
     */
    onAddButtonClick() {
      this.selectedTask = null;
      this.$nextTick(() => {
        this.$refs.taskSettingPopup.open();
      });
    },
    /**
     * 더보기 버튼 click
     * @author jeee12
     * @param  {[type]} row [description]
     */
    onDetailButtonClick(row) {
      this.selectedTask = row;
      this.$nextTick(() => {
        this.$refs.taskDetailPopup.open();
      });
    },
    onSelectionChange(selection) {
      this.checkedRows = selection;
    },
    handlerPaginationChange(_pagination) {
      this.pagination = _pagination;
    },
    onRowDblClick(row) {
      this.selectedTask = row;
      this.$nextTick(() => {
        this.$refs.taskSettingPopup.open();
      });
    },
    showTaskDetail(row) {
      this.selectedTask = row;
      this.$nextTick(() => {
        this.$refs.taskDetailPopup.open();
      });
      // this.activeView = 'WTaskDetailListView';
    },
    /**
     * 삭제 버튼 click
     * @author jeee12
     */
    onDeleteButtonClick() {
      // 기준정보가 아닌 row들만 삭제
      const editableRows = this.checkedRows.filter((data) => data.editableFlag === 'Y');
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        const target = '태스크';
        const action = msgUtil.action.DELETE;
        amsSettingsApi.deleteTaskList(editableRows).then((response) => {
          if (response.data.success) {
            this.loadData();
          }
          if (editableRows.length !== this.checkedRows.length) {
            this.$message({ duration: 4500, ...msgUtil.getCustomResultMsgData('기준정보는 삭제할 수 없습니다.', response.data.success) });
          }
          if (editableRows.length > 0) {
            this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }).catch(() => {});
    },
    /**
     * 태스크 복사
     * @author jeee12
     * @return {[type]} [description]
     */
    onCopyButtonClick() {
      const target = '태스크';
      const action = '복사';
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        amsSettingsApi.copyTaskList(this.checkedRows).then((response) => {
          if (response.data.success) {
            this.loadData();
          }
          this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }).catch(() => {});
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TaskSetting/components/TaskListView.vue